import { render, staticRenderFns } from "./TitleGroup.vue?vue&type=template&id=00618c08"
import script from "./TitleGroup.vue?vue&type=script&lang=js"
export * from "./TitleGroup.vue?vue&type=script&lang=js"
import style0 from "./TitleGroup.vue?vue&type=style&index=0&id=00618c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports